/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [余额流水明细↗](http://yapi.yishou.com/project/128/interface/api/29857) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.16.2`
 * @请求头 `POST /baob/Balance/cashLogDetail`
 */
const cashLogDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/Balance/cashLogDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["id"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "余额流水id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            id: { type: "string", description: "id" },
            supply_cash_log_type: { type: "string", description: "流水类型" },
            create_time: { type: "string", description: "交易时间" },
            money: { type: "string", description: "金额" },
            front_seq_no: { type: "string", description: "流水单号" },
            bank_no: { type: "string", description: "银行卡号" },
            bank_name: { type: "string", description: "银行名" },
            fail_reason: { type: "string", description: "失败原因" },
            is_fail: { type: "integer", description: "是否失败{0:否,1:是}" },
        },
        required: ["is_fail"],
    },
    requestFunctionName: "cashLogDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [余额流水明细↗](http://yapi.yishou.com/project/128/interface/api/29857) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.16.2`
 * @请求头 `POST /baob/Balance/cashLogDetail`
 */
export const cashLogDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cashLogDetailRequestConfig, requestData), ...args);
};
cashLogDetail.requestConfig = cashLogDetailRequestConfig;
/**
 * 接口 [根据城市获取主市场列表↗](http://yapi.yishou.com/project/128/interface/api/29939) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `获取“主市场”ID`
 * @请求头 `POST /erp/Supply/getMainMarket`
 */
const getMainMarketRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/getMainMarket",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["city"], properties: { city: { type: "string" } } },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                key: { type: ["number", "string"], description: "key" },
                label: { type: "string", description: "value" },
            },
            required: ["key", "label"],
        },
    },
    requestFunctionName: "getMainMarket",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据城市获取主市场列表↗](http://yapi.yishou.com/project/128/interface/api/29939) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `获取“主市场”ID`
 * @请求头 `POST /erp/Supply/getMainMarket`
 */
export const getMainMarket = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getMainMarketRequestConfig, requestData), ...args);
};
getMainMarket.requestConfig = getMainMarketRequestConfig;
/**
 * 接口 [获取子市场列表↗](http://yapi.yishou.com/project/128/interface/api/29940) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `获取“主市场”ID`
 * @请求头 `POST /erp/Supply/getChildMarket`
 */
const getChildMarketRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/getChildMarket",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["parent_id"],
        properties: { parent_id: { type: "string", description: "主市场id" } },
    },
    responseDataJsonSchema: { type: "object", title: "empty object", properties: {} },
    requestFunctionName: "getChildMarket",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取子市场列表↗](http://yapi.yishou.com/project/128/interface/api/29940) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `获取“主市场”ID`
 * @请求头 `POST /erp/Supply/getChildMarket`
 */
export const getChildMarket = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getChildMarketRequestConfig, requestData), ...args);
};
getChildMarket.requestConfig = getChildMarketRequestConfig;
/**
 * 接口 [供应商列表↗](http://yapi.yishou.com/project/128/interface/api/29964) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`, `买手小店`, `供应商合同管理`, `爆版4.28.0`
 * @请求头 `GET /erp/Supply/SupplyList`
 */
const supplyListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/SupplyList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [
        "reject_accept",
        "special_sale",
        "goods_exempt_examine",
        "supply_character",
        "supply_level",
        "is_return_profit",
        "clearing_form",
        "period_profit",
        "pre_storage_admin",
        "is_participation_dispense",
        "is_sign_pingan_agreement",
        "take_stock_on_plan",
        "is_authentication",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "reject_accept",
            "special_sale",
            "goods_exempt_examine",
            "supply_character",
            "supply_level",
            "is_return_profit",
            "clearing_form",
            "period_profit",
            "pre_storage_admin",
            "is_participation_dispense",
            "is_sign_pingan_agreement",
            "take_stock_on_plan",
            "is_authentication",
        ],
        properties: {
            reject_accept: { type: "string", description: "退换货是否接收:{0:否，1:是}" },
            special_sale: { type: "string", description: "供应商是否特价销售{0:否，1:是}" },
            goods_exempt_examine: { type: "string", description: "商品是否免除审核{0:否,1:是}" },
            supply_character: { type: "string", description: "-1: 全部 , 0:常规合作商,1:买手小店,2:小店渠道商" },
            supply_level: { type: "string", description: "供应商等级{S,A,B,C,D}" },
            is_return_profit: { type: "string", description: "是否参与让利销售{1:是,2:否}" },
            clearing_form: { type: "string", description: " 结算方式:{1:代采单抵扣,2:账单支付}" },
            period_profit: { type: "string", description: "让利账期:{1:月结,2:日结}" },
            pre_storage_admin: { type: "string", description: "前置仓跟进人名字模糊搜索" },
            is_participation_dispense: { type: "string", description: "是否参与小店分发{1:是,2:否}" },
            is_sign_pingan_agreement: { type: "string", description: "是否已签署结算通{1:是,2:否}" },
            take_stock_on_plan: { type: "string", description: "是否按计划点货{1:是,2:否}" },
            is_authentication: { type: "string", description: "是否已鉴权{1:是,2:否}" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            pages: { type: "number" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        is_signed_contract: { type: "string", description: "是否签约" },
                        settle_days: { type: "string", description: "账单结算周期" },
                        supply_id: { type: "string", description: "供应商ID" },
                        supply_name: { type: "string", description: "供应商名称" },
                        supplier_num: { type: "string", description: "供应商档口号" },
                        supply_mobile_phone: { type: "string", description: "手机" },
                        supply_wechat: { type: "string", description: "供应商微信" },
                        supply_floor: { type: "string", description: "供应商楼层" },
                        disable_count: { type: "string", description: "禁用次数" },
                        disable_remark: { type: "string", description: "禁用标记" },
                        supply_is_scal: { type: "string", description: "是否刷单" },
                        supply_is_strength: { type: "string", description: "是否实力档口" },
                        supply_supply_level: { type: "null", description: "档次，作废" },
                        limit_day: { type: "string", description: "排单天数" },
                        is_benchmarking: { type: "string", description: "是否履约率标杆供应商" },
                        as_plan: { type: "string", description: "售后提前采购计划" },
                        all_rebuild_plan: { type: "string", description: "重新采购计划全量生成" },
                        season: { type: "string", description: "季节" },
                        supply_grade: { type: "string", description: "供应商档次" },
                        age_group: { type: "string", description: "适合年龄" },
                        cat_ids: { type: "string", description: "擅长的分类" },
                        is_ka: { type: "string", description: "是否KA" },
                        supply_action_value: { type: "string", description: "默认活跃值" },
                        supply_area: { type: ["string", "null"], description: "供应商区域" },
                        supply_city: { type: "string", description: "供应商城市" },
                        supply_supply_status: { type: "string", description: "供应商状态" },
                        create_admin: { type: "string", description: "创建管理员" },
                        create_time: { type: "string", description: "创建时间" },
                        market: { type: "string", description: "市场" },
                        father_market: { type: "string", description: "一级市场" },
                        pgname: { type: "string", description: "采购员" },
                        dggroup: { type: "string", description: "次品组" },
                        dgmember: { type: "string", description: "次品员" },
                        settle_type: { type: "number", description: "结算方式{1:普通先款后货,2:先货后款}" },
                        supply_settle_type: { type: "string", description: "结算方式{1:普通先款后货,2:先货后款}" },
                        brands: { type: ["string", "null"], description: "供应商品牌" },
                        pg_name: { type: ["null", "string"], description: "采购组名称" },
                        member: { type: "string" },
                        picker_member_name: { type: "string", description: "采购员名称" },
                        company_name: { type: "null", description: "供应商公司名称" },
                        bind_type: {
                            type: "string",
                            description: "'绑定类型{1:核心档口}（现在只有核心档口了 保留这个字段方便以后拓展）",
                        },
                        supply_pgroup_relat: { type: ["null", "string"], description: "采购组名称" },
                        follower: { type: "null", description: "商家运营跟进人" },
                        supply_permissions_pay_method: { type: "string", description: "付款方法" },
                        pay_method: { type: "string", description: "付款方法" },
                        styles: { type: ["string", "null"], description: "没用" },
                        second_styles: { type: ["string", "null"], description: "没用" },
                        picker_group_member_name: { type: ["null", "string"], description: "采购组名字" },
                        auth_status: { type: "string", description: "是否绑卡以鉴权状态(0:未鉴权,1:已鉴权)" },
                        remark: { type: "string", description: "备注" },
                        no_reason_return: { type: "string", description: "供应商是否支持无理由退换:{0:否,1:是}" },
                        is_platform: { type: "string", description: "是否平台化供应商{0:否,1:是}" },
                        sale_level: { type: "string", description: "销售等级" },
                        update_sale_level: {
                            type: "string",
                            description: "销售等级,手动修改:{-1:无,0:l0,1:l1,2:l2,3:l3,4:l4,5:l5,6:l6}",
                        },
                        sub_acct_no: { type: "string", description: "平安银行子账户" },
                        refund_member_id: { type: ["string", "null"], description: "退供员ID" },
                        refund_model: { type: "string", description: "退货模式:{1:退货由一手处理,2:退货由商家处理}" },
                        expand_admin_id: { type: ["string", "null"], description: "商家拓展跟进人" },
                        reject_accept: { type: "string", description: "退换货是否需接收{0:否,1:是}" },
                        special_sale: { type: "string", description: "能否参与特价销售{0:否,1:是}" },
                        self_operation_special: { type: "string", description: "是否自运营专场{0:否,1:是}" },
                        supply_developer_admin: { type: "null", description: "供应商开发人" },
                        is_signed_contract_text: { type: "string" },
                        settle_days_text: { type: "string" },
                        refund_member_name: { type: "string", description: "退供员" },
                        expander: { type: "string" },
                        supply_character: {
                            type: "number",
                            tag: "买手小店",
                            description: "商家性质{0:常规合作商,1:买手小店,2:小店渠道商}",
                        },
                        supply_character_formal: { type: "string", description: "小店渠道商", tag: "买手小店" },
                        is_return_profit_format: { type: "string", tag: "爆版4.28.0", description: "是否让利销售" },
                        period_profit_format: { type: "string", description: "账单周期" },
                        clearing_form_format: { type: "string", description: "支付方式" },
                        pre_storage_admin: { type: "string", description: "前置仓跟进人id" },
                        pre_storage_admin_name: { type: "string", description: "前置跟进人名字" },
                        dispense_rates: { type: "string", description: "小店分发佣金(正,特价)" },
                        take_stock_on_plan: { type: "string", description: "是否按计划点货" },
                        is_sign_pingan_agreement: { type: "string", description: "是否已签署结算通" },
                        is_authentication: { type: "string", description: "是否已鉴权" },
                        is_bind_bank_bool: { type: "string", description: "提现绑卡鉴权{0否 1是}" },
                    },
                    required: [
                        "is_signed_contract",
                        "settle_days",
                        "supply_id",
                        "supply_name",
                        "supplier_num",
                        "supply_mobile_phone",
                        "supply_wechat",
                        "supply_floor",
                        "disable_count",
                        "disable_remark",
                        "supply_is_scal",
                        "supply_is_strength",
                        "supply_supply_level",
                        "limit_day",
                        "is_benchmarking",
                        "as_plan",
                        "all_rebuild_plan",
                        "season",
                        "supply_grade",
                        "age_group",
                        "cat_ids",
                        "is_ka",
                        "supply_action_value",
                        "supply_area",
                        "supply_city",
                        "supply_supply_status",
                        "create_admin",
                        "create_time",
                        "market",
                        "father_market",
                        "pgname",
                        "dggroup",
                        "dgmember",
                        "settle_type",
                        "supply_settle_type",
                        "brands",
                        "pg_name",
                        "member",
                        "picker_member_name",
                        "company_name",
                        "bind_type",
                        "supply_pgroup_relat",
                        "follower",
                        "supply_permissions_pay_method",
                        "pay_method",
                        "styles",
                        "second_styles",
                        "picker_group_member_name",
                        "auth_status",
                        "remark",
                        "no_reason_return",
                        "is_platform",
                        "sale_level",
                        "update_sale_level",
                        "sub_acct_no",
                        "refund_member_id",
                        "refund_model",
                        "expand_admin_id",
                        "reject_accept",
                        "special_sale",
                        "self_operation_special",
                        "supply_developer_admin",
                        "is_signed_contract_text",
                        "settle_days_text",
                        "refund_member_name",
                        "expander",
                        "supply_character",
                        "supply_character_formal",
                        "is_return_profit_format",
                        "clearing_form_format",
                        "period_profit_format",
                        "pre_storage_admin",
                        "pre_storage_admin_name",
                        "dispense_rates",
                        "is_authentication",
                        "is_sign_pingan_agreement",
                        "take_stock_on_plan",
                        "is_bind_bank_bool",
                    ],
                },
            },
            pg_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { pgid: { type: ["number", "string"] }, pgname: { type: "string" } },
                    required: ["pgid", "pgname"],
                },
            },
            pickers: {
                type: "array",
                items: {
                    type: "object",
                    properties: { pg_id: { type: ["number", "string"] }, pg_name: { type: "string" } },
                    required: ["pg_id", "pg_name"],
                },
            },
            floor: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: ["number", "string"] }, label: { type: ["string", "number"] } },
                    required: ["value", "label"],
                },
            },
            supply_area: {
                type: "array",
                items: {
                    type: "object",
                    properties: { supply_area_id: { type: ["number", "string"] }, supply_area: { type: "string" } },
                    required: ["supply_area_id", "supply_area"],
                },
            },
            market: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        key: { type: ["number", "string"] },
                        label: { type: "string" },
                        children: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    key: { type: ["number", "string"] },
                                    label: { type: "string" },
                                    show_brand: { type: "string" },
                                },
                                required: ["key", "label", "show_brand"],
                            },
                        },
                        show_brand: { type: "string" },
                    },
                    required: ["key", "label", "children", "show_brand"],
                },
            },
            memberOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            defectiveGroupOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            defectiveGroupMemberOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            refundMemberOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            followerOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            pay_methods: { type: "object", properties: { "1": { type: "string" }, "2": { type: "string" } } },
            sale_levels: { type: "array", items: { type: "string" } },
            refund_models: { type: "object", properties: { "1": { type: "string" }, "2": { type: "string" } } },
            level_options: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
                description: "供应商等级",
            },
        },
        required: ["level_options"],
    },
    requestFunctionName: "supplyList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商列表↗](http://yapi.yishou.com/project/128/interface/api/29964) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`, `买手小店`, `供应商合同管理`, `爆版4.28.0`
 * @请求头 `GET /erp/Supply/SupplyList`
 */
export const supplyList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(supplyListRequestConfig, requestData), ...args);
};
supplyList.requestConfig = supplyListRequestConfig;
/**
 * 接口 [新增供应商↗](http://yapi.yishou.com/project/128/interface/api/29965) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`, `合并账单`, `前置仓活动费用扣取`, `爆版4.28.0`
 * @请求头 `POST /erp/Supply/AddSupply`
 */
const addSupplyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/AddSupply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "reject_accept",
            "refund_member_id",
            "supply_address",
            "lng",
            "lat",
            "bill_merger_date",
            "activity_fee_buckle",
            "open_qz_auto_buckle",
            "is_return_profit",
            "return_profit_month",
            "clearing_form",
            "reserve_price",
            "return_profit_rule[0][num]",
            "return_profit_rule[0][price]",
            "period_profit",
            "is_auto_cancel_plan",
            "is_push_wcg_plan",
            "is_sync_supply_stock",
        ],
        properties: {
            supply_picker_group_member_id: { type: "string", description: "买手id" },
            all_rebuild_plan: { type: "string", description: "重新采购计划是否全量生成{0:否，1:是}" },
            reject_accept: { type: "string", description: "退换货是否需接收{0:否，1:是}" },
            refund_member_id: { type: "string", description: "退供员ID" },
            supply_address: { type: "string", description: "" },
            lng: { type: "string", description: "" },
            lat: { type: "string", description: "" },
            bill_merger_date: { type: "string", description: "合并账单日期" },
            can_return_days: { type: "string", description: "商品不退换日期" },
            activity_fee_buckle: { type: "string", description: "活动费扣取{1:账单方式}" },
            open_qz_auto_buckle: { type: "string", description: "开启前置仓自动扣减{1:自动扣减,2:不自动扣减}" },
            is_return_profit: { type: "string", description: "是否让利销售{1:是，2:否}" },
            return_profit_month: { type: "string", description: "生效日期{YY-MM-DD)" },
            clearing_form: { type: "string", description: "结算方式:{1:代采单抵扣,2:账单支付}" },
            reserve_price: { type: "string", description: "让利计算最低价" },
            "return_profit_rule[0][num]": { type: "string", description: "让利规则数量" },
            "return_profit_rule[0][price]": { type: "string", description: "让利规则价格" },
            period_profit: { type: "string", description: "让利账期:{1:月结,2:日结}" },
            is_auto_cancel_plan: { type: "string", description: "前置仓入库时消除待开单计划数据:{1:否;2:是}" },
            pre_storage_admin: { type: "string", description: "前置仓跟进人: 内部已启用的员工id" },
            is_push_wcg_plan: { type: "string", description: "是否推送采购计划给第三方:{1:是;2;否:}" },
            is_sync_supply_stock: { type: "string", description: "是否同步第三方实时库存:{1:是;2:否;}" },
        },
    },
    responseDataJsonSchema: { type: "object", title: "empty object", properties: {} },
    requestFunctionName: "addSupply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新增供应商↗](http://yapi.yishou.com/project/128/interface/api/29965) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`, `合并账单`, `前置仓活动费用扣取`, `爆版4.28.0`
 * @请求头 `POST /erp/Supply/AddSupply`
 */
export const addSupply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(addSupplyRequestConfig, requestData), ...args);
};
addSupply.requestConfig = addSupplyRequestConfig;
/**
 * 接口 [更新供应商↗](http://yapi.yishou.com/project/128/interface/api/29966) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`, `合并账单`, `爆版4.28.0`
 * @请求头 `POST /erp/Supply/UpdateSupply`
 */
const updateSupplyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/UpdateSupply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["reject_accept"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "special_sale",
            "self_operation_special",
            "goods_exempt_examine",
            "supply_address",
            "lng",
            "lat",
            "bill_merger_date",
            "is_deduct_repurchase",
            "supply_excess_point_goods",
            "activity_fee_buckle",
            "open_qz_auto_buckle",
            "is_return_profit",
            "return_profit_month",
            "clearing_form",
            "reserve_price",
            "return_profit_rule[0][num]",
            "return_profit_rule[0][price]",
            "period_profit",
            "is_auto_billing",
            "is_auto_cancel_plan",
            "create_order_way",
            "is_push_wcg_plan",
            "is_sync_supply_stock",
            "no_reason_return",
            "no_reason_begin_time",
            "refund_model",
            "refund_service_fee_rate",
            "return_limit_ratio",
            "reject_accept",
        ],
        properties: {
            reject_accept: { type: "string", description: "退换货是否需接收{0:否，1:是}" },
            special_sale: { type: "string", description: "供应商是否特价销售{0:否，1:是}" },
            self_operation_special: { type: "string", description: "供应商是否自运营专场{0:否，1:是}" },
            goods_exempt_examine: { type: "string", description: "商品发布免审{0:否，1:是}" },
            supply_address: { type: "string", description: "" },
            lng: { type: "string", description: "" },
            lat: { type: "string", description: "" },
            bill_merger_date: { type: "string", description: "合并账单日期" },
            is_deduct_repurchase: { type: "string", description: "是否转抵扣并重采：1=是 0=否" },
            supply_excess_point_goods: { type: "string", description: "前置仓商品是否可以超点入库:{1:否,2:是}" },
            activity_fee_buckle: { type: "string", description: "活动费扣取方式{1:账单方式}" },
            open_qz_auto_buckle: { type: "string", description: "开启前置仓自动扣取{1:自动扣取，2:不自动扣取}" },
            is_return_profit: { type: "string", description: "是否让利销售{1:是，2:否}" },
            return_profit_month: { type: "string", description: "生效日期{YY-MM-DD)" },
            clearing_form: { type: "string", description: "结算方式:{1:代采单抵扣,2:账单支付}" },
            reserve_price: { type: "string", description: "让利计算最低价" },
            "return_profit_rule[0][num]": { type: "string", description: "让利规则数组，月度销售件数达标门槛" },
            "return_profit_rule[0][price]": { type: "string", description: "让利规则数组，让利单价" },
            period_profit: { type: "string", description: "让利账单生成周期{1:月结,2:日结}" },
            is_auto_billing: { type: "string", description: "是否自动开单:{1:否;2:排单单;3:实数单;}" },
            is_auto_cancel_plan: { type: "string", description: "前置仓入库时消除待开单计划数据:{1:否;2:是}" },
            create_order_way: {
                type: "string",
                description: "第三方发货生成采购单方式:{1:按发货批次;2:按采购计划(销售订货单);}",
            },
            pre_storage_admin: { type: "string", description: "前置仓跟进人:内部已启用的员工id" },
            is_push_wcg_plan: { type: "string", description: " 是否推送采购计划给第三方:{1:是;2;否:}" },
            is_sync_supply_stock: { type: "string", description: "是否同步第三方实时库存:{1:是;2:否;}" },
            no_reason_return: { type: "string", description: "供应商是否支持无理由退换:{0:否,1:是}" },
            no_reason_begin_time: { type: "string", description: "退货服务开始时间" },
            refund_model: { type: "string", description: "退货模式:{1:退货由一手处理,2:退货由商家处理}" },
            refund_service_fee_rate: { type: "string", description: "退货服务比例" },
            return_limit_ratio: { type: "string", description: "退货限制比例" },
        },
    },
    responseDataJsonSchema: { type: "object", title: "empty object", properties: {} },
    requestFunctionName: "updateSupply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [更新供应商↗](http://yapi.yishou.com/project/128/interface/api/29966) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`, `合并账单`, `爆版4.28.0`
 * @请求头 `POST /erp/Supply/UpdateSupply`
 */
export const updateSupply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateSupplyRequestConfig, requestData), ...args);
};
updateSupply.requestConfig = updateSupplyRequestConfig;
/**
 * 接口 [根据买手组id获取买手组人员↗](http://yapi.yishou.com/project/128/interface/api/29968) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`
 * @请求头 `POST /erp/Common/getPickerGroupMember`
 */
const getPickerGroupMemberRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getPickerGroupMember",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pg_id"],
        properties: { pg_id: { type: "string", description: "买手组id" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { label: { type: "string" }, value: { type: "string" } },
            required: ["label", "value"],
        },
    },
    requestFunctionName: "getPickerGroupMember",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据买手组id获取买手组人员↗](http://yapi.yishou.com/project/128/interface/api/29968) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `退换货是否接收`
 * @请求头 `POST /erp/Common/getPickerGroupMember`
 */
export const getPickerGroupMember = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getPickerGroupMemberRequestConfig, requestData), ...args);
};
getPickerGroupMember.requestConfig = getPickerGroupMemberRequestConfig;
/**
 * 接口 [获取次品组下的次品员和退供员↗](http://yapi.yishou.com/project/128/interface/api/31998) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Defective/getGroupMember`
 */
const getGroupMemberRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Defective/getGroupMember",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dgid"],
        properties: { dgid: { type: "string", description: "次品组id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            member: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: "次品员id" },
                        label: { type: "string", description: "次品员名字" },
                    },
                },
                description: "次品员",
            },
            refundMember: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: "退供员id" },
                        label: { type: "string", description: "退供员名字" },
                    },
                },
                description: "退供员",
            },
        },
    },
    requestFunctionName: "getGroupMember",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取次品组下的次品员和退供员↗](http://yapi.yishou.com/project/128/interface/api/31998) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Defective/getGroupMember`
 */
export const getGroupMember = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getGroupMemberRequestConfig, requestData), ...args);
};
getGroupMember.requestConfig = getGroupMemberRequestConfig;
/**
 * 接口 [供应商画像↗](http://yapi.yishou.com/project/128/interface/api/32626) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/Supply/profile`
 */
const profileRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/profile",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["supply_id"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            portrait: {
                type: "object",
                properties: {
                    ave_quality_va: { type: "number" },
                    avergesocre_va: { type: "number" },
                    engough_rates: { type: "string" },
                    fg_user_rates: { type: "string" },
                    hot_rates: { type: "string" },
                    noreason_rates: { type: "string" },
                    problem_rates: { type: "string" },
                    service_rates: { type: "string" },
                    whole_rates: { type: "string" },
                },
            },
            portrait_data: {
                type: "object",
                properties: {
                    "7": {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                "24_allot_rates": { type: "string" },
                                "24_billing_rates": { type: "string" },
                                "24_ship_rates": { type: "string" },
                                "24_stock_rates": { type: "string" },
                                "48_allot_rates": { type: "string" },
                                "48_billing_rates": { type: "string" },
                                "48_ship_rates": { type: "string" },
                                "48_stock_rates": { type: "string" },
                                end_allot_rates: { type: "string" },
                                end_billing_rates: { type: "string" },
                                end_ship_rates: { type: "string" },
                                end_stock_rates: { type: "string" },
                            },
                        },
                    },
                    "15": {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                "24_allot_rates": { type: "string" },
                                "24_billing_rates": { type: "string" },
                                "24_ship_rates": { type: "string" },
                                "24_stock_rates": { type: "string" },
                                "48_allot_rates": { type: "string" },
                                "48_billing_rates": { type: "string" },
                                "48_ship_rates": { type: "string" },
                                "48_stock_rates": { type: "string" },
                                end_allot_rates: { type: "string" },
                                end_billing_rates: { type: "string" },
                                end_ship_rates: { type: "string" },
                                end_stock_rates: { type: "string" },
                            },
                        },
                    },
                    "30": {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                "24_allot_rates": { type: "string" },
                                "24_billing_rates": { type: "string" },
                                "24_ship_rates": { type: "string" },
                                "24_stock_rates": { type: "string" },
                                "48_allot_rates": { type: "string" },
                                "48_billing_rates": { type: "string" },
                                "48_ship_rates": { type: "string" },
                                "48_stock_rates": { type: "string" },
                                end_allot_rates: { type: "string" },
                                end_billing_rates: { type: "string" },
                                end_ship_rates: { type: "string" },
                                end_stock_rates: { type: "string" },
                            },
                        },
                    },
                    "90": {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                "24_allot_rates": { type: "string" },
                                "24_billing_rates": { type: "string" },
                                "24_ship_rates": { type: "string" },
                                "24_stock_rates": { type: "string" },
                                "48_allot_rates": { type: "string" },
                                "48_billing_rates": { type: "string" },
                                "48_ship_rates": { type: "string" },
                                "48_stock_rates": { type: "string" },
                                end_allot_rates: { type: "string" },
                                end_billing_rates: { type: "string" },
                                end_ship_rates: { type: "string" },
                                end_stock_rates: { type: "string" },
                            },
                        },
                    },
                },
            },
            profile: {
                type: "object",
                properties: {
                    advantage: { type: "string" },
                    age_group: { type: "string" },
                    avatar: { type: "string" },
                    brands: { type: "string" },
                    cat_ids: { type: "string" },
                    cats: { type: "string" },
                    create_time: { type: "string" },
                    disadvantage: { type: "string" },
                    father_market: { type: "string" },
                    license: { type: "string" },
                    limit_day: { type: "string" },
                    market: { type: "string" },
                    mbmber: { type: "string" },
                    payees: {
                        type: "object",
                        properties: {
                            field_51: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        payee_bank: { type: "string" },
                                        payee_bank_account: { type: "string" },
                                        payee_name: { type: "string" },
                                    },
                                },
                            },
                        },
                    },
                    pg_name: { type: "string" },
                    pgid: { type: "string" },
                    pgname: { type: "string" },
                    pic: { type: "string" },
                    season: { type: "string" },
                    styles: { type: "string" },
                    supplier_num: { type: "string" },
                    supply_area: { type: "string" },
                    supply_city: { type: "string" },
                    supply_floor: { type: "string" },
                    supply_id: { type: "string" },
                    supply_is_scal: { type: "string" },
                    supply_is_strength: { type: "string" },
                    supply_mobile_phone: { type: "string" },
                    supply_name: { type: "string" },
                    supply_supply_level: { type: "string" },
                    supply_supply_status: { type: "string" },
                    supply_wechat: { type: "string" },
                },
                required: ["supply_wechat", "supply_supply_status", "supply_supply_level"],
            },
            wcg_order: { type: "array", items: { type: "string" } },
            perform_data: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        block_id: { type: "string", description: "板块id" },
                        block_name: { type: "string", description: "板块名称" },
                        block_desc: { type: "string", description: "板块字段说明" },
                        custom_fields: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    field_id: { type: "string", description: "自定义字段id" },
                                    field_name: { type: "string", description: "自定义字段名称" },
                                    field_value: { type: "string", description: "自定义字段值" },
                                    field_desc: { type: "string", description: "自定义字段说明" },
                                },
                            },
                        },
                    },
                    required: ["block_id", "block_name", "block_desc", "custom_fields"],
                },
                description: "供应商履约信息",
            },
        },
    },
    requestFunctionName: "profile",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商画像↗](http://yapi.yishou.com/project/128/interface/api/32626) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/Supply/profile`
 */
export const profile = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(profileRequestConfig, requestData), ...args);
};
profile.requestConfig = profileRequestConfig;
/**
 * 接口 [供应商画像-获取履约信息↗](http://yapi.yishou.com/project/128/interface/api/32710) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/SupplyPerform/getPerform`
 */
const getPerformRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPerform/getPerform",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["supply_id"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                block_id: { type: "string", description: "板块id" },
                block_name: { type: "string", description: "板块名称" },
                block_desc: { type: "string", description: "板块字段说明" },
                custom_fields: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            field_id: { type: "string", description: "字段id" },
                            field_type: { type: "string", description: "1填写，2选项，3时间" },
                            field_name: { type: "string", description: "字段名称" },
                            field_require: { type: "string", description: "字段是否必填" },
                            field_desc: { type: "string", description: "字段说明" },
                            field_values: {
                                type: "object",
                                properties: {
                                    field_value: { type: "string", description: "自定字段值，仅适用填写和选项类型" },
                                    date_start: { type: "string", description: "仅适用开始日期，开始日期写入此字段" },
                                    date_end: { type: "string", description: "仅适用结束日期，结束日期写入此字段" },
                                    time_start: { type: "string", description: "仅适用开始时间，开始时间写入此字段" },
                                    time_end: { type: "string", description: "仅适用结束时间，结束时间写入此字段" },
                                },
                            },
                            option_type: {
                                type: "string",
                                description: "填写和选项为0，字段类型为时间时，1为时间点，2时间段，3日期，4日期范围，5日期&时间点，6日期范围&时间段",
                            },
                        },
                    },
                },
            },
        },
    },
    requestFunctionName: "getPerform",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商画像-获取履约信息↗](http://yapi.yishou.com/project/128/interface/api/32710) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/SupplyPerform/getPerform`
 */
export const getPerform = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getPerformRequestConfig, requestData), ...args);
};
getPerform.requestConfig = getPerformRequestConfig;
/**
 * 接口 [供应商画像-保存履约信息↗](http://yapi.yishou.com/project/128/interface/api/32714) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPerform/savePerform`
 */
const savePerformRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPerform/savePerform",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            supply_id: { type: "integer", description: "12" },
            perform_data: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        block_id: { type: "integer", description: "1" },
                        block_name: { type: "string", description: '"开单信息"' },
                        custom_fields: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    field_id: { type: "integer", description: "1" },
                                    option_type: { type: "integer" },
                                    field_values: {
                                        type: "object",
                                        properties: { field_value: { type: "string", description: '"我是填写类型"' } },
                                        additionalProperties: false,
                                    },
                                },
                                additionalProperties: false,
                            },
                            description: '[{"field_id":1,"option_type":0,"field_values":{"field_value":"我是填写类型"}},{"field_id":2,"option_type":0,"field_values":{"field_value":"我是选项类型值"}},{"field_id":3,"option_type":1,"field_values":{"time_start":"我是时间点值 06:00:00"}},{"field_id":4,"option_type":2,"field_values":{"time_start":"我是时间段开始值 06:00:00","time_end":"我是时间段结束值 06:00:00"}},{"field_id":5,"option_type":3,"field_values":{"date_start":"我是日期值2020-12-15"}},{"field_id":6,"option_type":4,"field_values":{"date_start":"我是日期范围开始值2020-12-15","date_end":"我是日期范围结束值2020-12-15"}},{"field_id":7,"option_type":5,"field_values":{"time_start":"我是日期&时间点的时间值 06:00:00","date_start":"我是日期&时间点的日期值2020-12-15"}},{"field_id":8,"option_type":6,"field_values":{"time_start":"日期范围&时间段的时间开始值2020-12-15","time_end":"日期范围&时间段的时间结束值2020-12-15","date_start":"日期范围&时间段的日期开始值2020-12-15","date_end":"日期范围&时间段的日期结束值2020-12-15"}}]',
                        },
                    },
                    additionalProperties: false,
                },
                description: '[{"block_id":1,"block_name":"开单信息","custom_fields":[{"field_id":1,"option_type":0,"field_values":{"field_value":"我是填写类型"}},{"field_id":2,"option_type":0,"field_values":{"field_value":"我是选项类型值"}},{"field_id":3,"option_type":1,"field_values":{"time_start":"我是时间点值 06:00:00"}},{"field_id":4,"option_type":2,"field_values":{"time_start":"我是时间段开始值 06:00:00","time_end":"我是时间段结束值 06:00:00"}},{"field_id":5,"option_type":3,"field_values":{"date_start":"我是日期值2020-12-15"}},{"field_id":6,"option_type":4,"field_values":{"date_start":"我是日期范围开始值2020-12-15","date_end":"我是日期范围结束值2020-12-15"}},{"field_id":7,"option_type":5,"field_values":{"time_start":"我是日期&时间点的时间值 06:00:00","date_start":"我是日期&时间点的日期值2020-12-15"}},{"field_id":8,"option_type":6,"field_values":{"time_start":"日期范围&时间段的时间开始值2020-12-15","time_end":"日期范围&时间段的时间结束值2020-12-15","date_start":"日期范围&时间段的日期开始值2020-12-15","date_end":"日期范围&时间段的日期结束值2020-12-15"}}]}]',
            },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "savePerform",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商画像-保存履约信息↗](http://yapi.yishou.com/project/128/interface/api/32714) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPerform/savePerform`
 */
export const savePerform = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(savePerformRequestConfig, requestData), ...args);
};
savePerform.requestConfig = savePerformRequestConfig;
/**
 * 接口 [供应商画像-导出履约信息↗](http://yapi.yishou.com/project/128/interface/api/32718) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPerform/exportPerform`
 */
const exportPerformRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPerform/exportPerform",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "下载文件" } } },
    requestFunctionName: "exportPerform",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商画像-导出履约信息↗](http://yapi.yishou.com/project/128/interface/api/32718) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPerform/exportPerform`
 */
export const exportPerform = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportPerformRequestConfig, requestData), ...args);
};
exportPerform.requestConfig = exportPerformRequestConfig;
/**
 * 接口 [供应商退出免审↗](http://yapi.yishou.com/project/128/interface/api/32842) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/exitExemptExamine`
 */
const exitExemptExamineRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/exitExemptExamine",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "goods_exempt_examine"],
        properties: {
            supply_id: { type: "string", description: "供应商ID" },
            goods_exempt_examine: { type: "string", description: "商品发布免审{0:否，1:是}" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {}, description: "数据" },
    requestFunctionName: "exitExemptExamine",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商退出免审↗](http://yapi.yishou.com/project/128/interface/api/32842) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/exitExemptExamine`
 */
export const exitExemptExamine = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exitExemptExamineRequestConfig, requestData), ...args);
};
exitExemptExamine.requestConfig = exitExemptExamineRequestConfig;
/**
 * 接口 [供应商画像-获取供应商履约信息日志↗](http://yapi.yishou.com/project/128/interface/api/32906) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/SupplyPerform/getPerformLog`
 */
const getPerformLogRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPerform/getPerformLog",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["supply_id", "page"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "page"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            page: { type: "string", description: "分页页码" },
        },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                event: { type: "string", description: "事件" },
                content: { type: "array", items: { type: "string", description: "一行日志" }, description: "内容" },
                operator: { type: "string", description: "操作人" },
                created: { type: "string", description: "操作事件" },
            },
            required: ["event", "content", "operator", "created"],
        },
    },
    requestFunctionName: "getPerformLog",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商画像-获取供应商履约信息日志↗](http://yapi.yishou.com/project/128/interface/api/32906) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/SupplyPerform/getPerformLog`
 */
export const getPerformLog = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getPerformLogRequestConfig, requestData), ...args);
};
getPerformLog.requestConfig = getPerformLogRequestConfig;
/**
 * 接口 [设置供应商商家性质↗](http://yapi.yishou.com/project/128/interface/api/33088) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `买手小店`
 * @请求头 `POST /erp/Supply/setSupplyCharacter`
 */
const setSupplyCharacterRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/setSupplyCharacter",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "supply_character"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            supply_character: { type: "string", description: "商家性质 0:常规合作商,1:买手小店,2:小店渠道商" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setSupplyCharacter",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置供应商商家性质↗](http://yapi.yishou.com/project/128/interface/api/33088) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `买手小店`
 * @请求头 `POST /erp/Supply/setSupplyCharacter`
 */
export const setSupplyCharacter = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setSupplyCharacterRequestConfig, requestData), ...args);
};
setSupplyCharacter.requestConfig = setSupplyCharacterRequestConfig;
/**
 * 接口 [查询供应商经营信息↗](http://yapi.yishou.com/project/128/interface/api/33276) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `供应商合同管理`, `爆版4.23.0`, `供应商添加海报`
 * @请求头 `POST /erp/supply/getManagement`
 */
const getManagementRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/supply/getManagement",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            level_options: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                    tag: "供应商合同管理",
                },
                description: "供应商等级下拉",
                tag: "供应商合同管理",
            },
            data: {
                type: "object",
                properties: {
                    payees: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                payee_id: { type: "string", description: "收款人id", tag: "供应商合同管理" },
                                supply_id: { type: "string", description: "供应商id" },
                                payee_name: { type: "string", description: "收款人名字" },
                                payee_bank: { type: "string", description: "收款人银行" },
                                payee_bank_account: { type: "string", description: "收款人账号" },
                                is_default: { type: "string", description: "是否默认" },
                                cnap_name: { type: "string", description: "收款人银行支行" },
                                cnap: { type: "string", description: "联行号" },
                            },
                            tag: "供应商合同管理",
                        },
                        description: "收款人",
                        tag: "供应商合同管理",
                    },
                    is_default_payees: { type: "number", description: "默认收款人索引" },
                    contract: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                sc_id: { type: "string", description: "合同id" },
                                sc_name: { type: "string", description: "合同名字" },
                                start_time: { type: "string", description: "开始时间" },
                                end_time: { type: "string", description: "结束时间" },
                                sign_time: { type: "string", tag: "爆版4.23.0", description: "签署时间" },
                                sc_type: { type: "string", tag: "爆版4.23.0", description: "合同类型{线上，线下}" },
                                scan_image: { type: "string", description: "扫描件url" },
                            },
                            required: ["sc_id", "sc_name", "start_time", "end_time", "scan_image", "sign_time", "sc_type"],
                        },
                        description: "合同信息",
                    },
                    management: {
                        type: "object",
                        properties: {
                            avatar: { type: "string", description: "品牌logo" },
                            license: { type: "string", description: "营业执照" },
                            wx_picture: { type: "string", description: "微信图片" },
                            wx_no: { type: "string", description: "录入微信号" },
                            picture: { type: "array", items: { type: "string" }, description: "档口实拍图" },
                            pic: { type: "string", description: "档口底图" },
                            supply_wechat: { type: "string", description: "供应商微信" },
                            supply_video: { type: "string", description: "供应商视屏" },
                            supply_images: { type: "array", items: { type: "string" }, description: "工作室图片" },
                            supply_mobile_phone: { type: "string", description: "供应商电话" },
                            supply_level: { type: "string", description: "供应商等级" },
                            front_id_card: { type: "string", description: "身份证正面" },
                            back_id_card: { type: "string", description: "身份证反面" },
                            settle_certificate: { type: "string", description: "待结算证明" },
                            posters: { type: "string", description: "海报", tag: "供应商添加海报" },
                            posters_url: { type: "string", description: "海报url", tag: "供应商添加海报" },
                        },
                        required: ["posters", "posters_url"],
                    },
                },
                tag: "供应商合同管理",
            },
        },
        tag: "供应商合同管理",
    },
    requestFunctionName: "getManagement",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [查询供应商经营信息↗](http://yapi.yishou.com/project/128/interface/api/33276) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `供应商合同管理`, `爆版4.23.0`, `供应商添加海报`
 * @请求头 `POST /erp/supply/getManagement`
 */
export const getManagement = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getManagementRequestConfig, requestData), ...args);
};
getManagement.requestConfig = getManagementRequestConfig;
/**
 * 接口 [修改供应商经营信息↗](http://yapi.yishou.com/project/128/interface/api/33277) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `供应商合同管理`, `爆版4.23.0`, `供应商添加海报`
 * @请求头 `POST /erp/supply/updateManagement`
 */
const updateManagementRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/supply/updateManagement",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "avatar",
            "license",
            "wx_picture",
            "wx_no",
            "supply_video",
            "supply_images",
            "supply_mobile_phone",
            "supply_wechat",
            "pic[0]",
            "picture[0]",
            "picture[1]",
            "supply_level",
            "front_id_card",
            "back_id_card",
            "settle_certificate",
            "payees[0][payee_id]",
            "payees[0][payee_name]",
            "payees[0][payee_bank]",
            "payees[0][payee_bank_account]",
            "payees[0][cnap]",
            "payees[0][cnap_name]",
            "payees[0][is_default]",
            "is_default",
            "supply_id",
            "contracts[0][sc_id]",
            "contracts[0][sc_name]",
            "contracts[0][start_time]",
            "contracts[0][end_time]",
            "contracts[0][scan_image]",
            "contracts[0][sign_time]",
            "supply_address",
            "lng",
            "lat",
            "posters",
        ],
        properties: {
            avatar: { type: "string", description: "品牌logo" },
            license: { type: "string", description: "营业执照" },
            wx_picture: { type: "string", description: "微信照片" },
            wx_no: { type: "string", description: "录入微信号" },
            supply_video: { type: "string", description: "供应商视屏" },
            supply_images: { type: "string", description: "工作室图片" },
            supply_mobile_phone: { type: "string", description: "供应商电话" },
            supply_wechat: { type: "string", description: "供应商微信" },
            "pic[0]": { type: "string", description: "档口底图" },
            "picture[0]": { type: "string", description: "档口实拍图" },
            "picture[1]": { type: "string", description: "档口实拍图" },
            supply_level: { type: "string", description: "供应商等级" },
            front_id_card: { type: "string", description: "身份证正面" },
            back_id_card: { type: "string", description: "身份证反面" },
            settle_certificate: { type: "string", description: "待结算证明" },
            "payees[0][payee_id]": { type: "string", description: "收款人id" },
            "payees[0][payee_name]": { type: "string", description: "收款人名字" },
            "payees[0][payee_bank]": { type: "string", description: "收款人银行" },
            "payees[0][payee_bank_account]": { type: "string", description: "收款人银行账号" },
            "payees[0][cnap]": { type: "string", description: "支行联号" },
            "payees[0][cnap_name]": { type: "string", description: "支行名称" },
            "payees[0][is_default]": { type: "string", description: "是否默认收款人" },
            is_default: { type: "string", description: "默认收款人索引" },
            supply_id: { type: "string", description: "供应商id" },
            "contracts[0][sc_id]": { type: "string", description: "合同id，如果新增则为0" },
            "contracts[0][sc_name]": { type: "string", description: "合同名字" },
            "contracts[0][start_time]": { type: "string", description: "合同开始时间" },
            "contracts[0][end_time]": { type: "string", description: "合同结束时间" },
            "contracts[0][scan_image]": { type: "string", description: "扫描件" },
            "contracts[0][sign_time]": { type: "string", description: "签署时间" },
            supply_address: { type: "string", description: "供应商地址" },
            lng: { type: "string", description: "经度" },
            lat: { type: "string", description: "维度" },
            posters: { type: "string", description: "供应商海报" },
        },
    },
    responseDataJsonSchema: { type: "string", description: "无" },
    requestFunctionName: "updateManagement",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [修改供应商经营信息↗](http://yapi.yishou.com/project/128/interface/api/33277) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `供应商合同管理`, `爆版4.23.0`, `供应商添加海报`
 * @请求头 `POST /erp/supply/updateManagement`
 */
export const updateManagement = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateManagementRequestConfig, requestData), ...args);
};
updateManagement.requestConfig = updateManagementRequestConfig;
/**
 * 接口 [导出供应商合同信息↗](http://yapi.yishou.com/project/128/interface/api/33278) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `供应商合同管理`
 * @请求头 `POST /erp/supply/exportSupplyContract`
 */
const exportSupplyContractRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/supply/exportSupplyContract",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "is_excel"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            is_excel: { type: "string", description: "导出编号，必须填2" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "文件url" } } },
    requestFunctionName: "exportSupplyContract",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导出供应商合同信息↗](http://yapi.yishou.com/project/128/interface/api/33278) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `供应商合同管理`
 * @请求头 `POST /erp/supply/exportSupplyContract`
 */
export const exportSupplyContract = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportSupplyContractRequestConfig, requestData), ...args);
};
exportSupplyContract.requestConfig = exportSupplyContractRequestConfig;
/**
 * 接口 [获取平台化信息↗](http://yapi.yishou.com/project/128/interface/api/33360) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/Supply/getSupplyPlatformInfo`
 */
const getSupplyPlatformInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/getSupplyPlatformInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            supply_id: { type: "string" },
            supply_name: { type: "string" },
            supply_mobile_phone: { type: "string" },
            supply_telephone: { type: "string" },
            supply_wechat: { type: "string" },
            supply_status: { type: "string" },
            limit_day: { type: "string" },
            create_time: { type: "string" },
            create_admin: { type: "string" },
            update_time: { type: "string" },
            pgid: { type: "string" },
            supply_floor: { type: "string" },
            supply_area_id: { type: "string" },
            is_scal: { type: "string" },
            market_id: { type: "string" },
            supply_level: { type: "string" },
            settle_type: { type: "string" },
            settle_days: { type: "string" },
            next_settle_start_time: { type: "string" },
            last_settle_time: { type: "string" },
            need_settle_flag: { type: "string" },
            purchase_status: { type: "string" },
            share_status: { type: "string" },
            the_new_flag: { type: "string" },
            is_signed_contract: { type: "string" },
            city: { type: "string" },
            remark: { type: "string" },
            supplier_num: { type: "string" },
            pic: { type: "string" },
            auto_time: { type: "string" },
            is_strength: { type: "string" },
            license: { type: "string" },
            season: { type: "string" },
            age_group: { type: "string" },
            cat_ids: { type: "string" },
            styles: { type: "string" },
            cat_char: { type: "string" },
            styles_char: { type: "string" },
            is_show_brand: { type: "string" },
            advantage: { type: "string" },
            disadvantage: { type: "string" },
            avatar: { type: "string" },
            is_full: { type: "string" },
            is_self: { type: "string" },
            supply_nickname: { type: "string" },
            pg_member_id: { type: "string" },
            pg_id: { type: "string" },
            is_live: { type: "string" },
            live_type: { type: "string" },
            live_num: { type: "string" },
            is_lower_enter: { type: "string" },
            is_ka: { type: "string" },
            m_goal: { type: "string" },
            pg_say: { type: "string" },
            disable_count: { type: "string" },
            disable_remark: { type: "string" },
            is_order_ability: { type: "string" },
            shopId: { type: "number" },
            is_all_style: { type: "string" },
            baobmobile: { type: "string" },
            baob_allot: { type: "string" },
            fans: { type: "string" },
            baob_stock_sharing: { type: "string" },
            first_sync_time: { type: "string" },
            picture: { type: "string" },
            wcg_order_sync_time: { type: "string" },
            supply_grade: { type: "string" },
            second_styles: { type: "string" },
            is_benchmarking: { type: "string" },
            is_self_need_audit: { type: "string" },
            supply_picker_group_member_id: { type: "string" },
            as_plan: { type: "string" },
            all_rebuild_plan: { type: "string" },
            supply_developer_admin: { type: "string" },
            dgid: { type: "string" },
            dg_member_id: { type: "string" },
            recommend_desc: { type: "string" },
            follower_admin_id: { type: "string" },
            is_screenshot_for_add_goods: { type: "string" },
            sub_acct_no: { type: "string" },
            is_sign: { type: "string" },
            supply_action_value: { type: "string" },
            day_new_limit: { type: "string" },
            month_new_limit: { type: "null" },
            father_market: { type: "string" },
            brand_id: { type: "string" },
            invitation_in: { type: "string" },
            open_deposit: { type: "string" },
            current_security_amount: { type: "string" },
            need_security_amount: { type: "string" },
            pay_method: { type: "string" },
            effective_time: { type: "string" },
            self_set_sole: { type: "string" },
            no_reason_return: { type: "string" },
            is_platform: { type: "string" },
            refund_model: { type: "string" },
            wx_picture: { type: "string" },
            wx_no: { type: "string" },
            supply_video: { type: "string" },
            supply_images: { type: "string" },
            sale_level: { type: "string" },
            refund_service_fee_rate: { type: "string" },
            update_sale_level: { type: "number" },
            update_refund_service_fee_rate: { type: "string" },
            service_fee_rate: { type: "string" },
            update_service_fee_rate: { type: "string" },
            platform_security_amount: { type: "string" },
            platform_year_amount: { type: "string" },
            refund_member_id: { type: "string" },
            no_reason_begin_time: { type: "string" },
            platform_switch: { type: "string", description: "平台佣金扣取是否开启{1:是;2:否}" },
            platform_begin_time: { type: "string", description: "平台佣金协议开始时间（日期格式）" },
            expand_admin_id: { type: "string" },
            reject_accept: { type: "string" },
            special_sale: { type: "string" },
            self_operation_special: { type: "string" },
            goods_exempt_examine: { type: "string" },
            return_limit_ratio: { type: "string" },
            week_new_limit: { type: "null" },
            is_show_best_choice: { type: "string", description: "是否展示严选品牌{1:是,2:否}" },
            contract_type_id: { type: "string", description: "合同模式id" },
            is_platform_text: { type: "string" },
            no_reason_return_text: { type: "string" },
            sale_level_text: { type: "string" },
            update_sale_level_text: { type: "string" },
            new_audit_status: { type: "string" },
            is_show_best_choice_text: { type: "string", description: "是否展示严选品牌{是,否}" },
            refund_models: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            sale_levels: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            contract_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: "合同模式id" },
                        label: { type: "string", description: "合同模式名称" },
                    },
                    required: ["value", "label"],
                },
                description: "合同模式配置项",
            },
        },
        required: ["platform_begin_time", "platform_switch"],
    },
    requestFunctionName: "getSupplyPlatformInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取平台化信息↗](http://yapi.yishou.com/project/128/interface/api/33360) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/Supply/getSupplyPlatformInfo`
 */
export const getSupplyPlatformInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplyPlatformInfoRequestConfig, requestData), ...args);
};
getSupplyPlatformInfo.requestConfig = getSupplyPlatformInfoRequestConfig;
/**
 * 接口 [更新平台化信息↗](http://yapi.yishou.com/project/128/interface/api/33361) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/Supply/saveSupplyPlatformInfo`
 */
const saveSupplyPlatformInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/saveSupplyPlatformInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "supply_id",
            "is_platform",
            "sale_level",
            "no_reason_return",
            "no_reason_begin_time",
            "refund_model",
            "refund_service_fee_rate",
            "service_fee_rate",
            "return_limit_ratio",
            "is_show_best_choice",
            "contract_type_id",
            "platform_begin_time",
            "platform_switch",
        ],
        properties: {
            supply_id: { type: "string" },
            is_platform: { type: "string", description: "" },
            sale_level: { type: "string", description: "" },
            no_reason_return: { type: "string", description: "" },
            no_reason_begin_time: { type: "string", description: "" },
            refund_model: { type: "string", description: "" },
            refund_service_fee_rate: { type: "string", description: "" },
            service_fee_rate: { type: "string", description: "" },
            return_limit_ratio: { type: "string", description: "退货限制比例" },
            is_show_best_choice: { type: "string", description: "是否展示严选品牌{1:是,2:否}" },
            contract_type_id: { type: "string", description: "合同模式id" },
            platform_begin_time: { type: "string", description: "平台佣金协议开始时间 （日期格式）" },
            platform_switch: { type: "string", description: "平台佣金扣取是否开启{1:是;2:否}" },
        },
    },
    responseDataJsonSchema: {},
    requestFunctionName: "saveSupplyPlatformInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [更新平台化信息↗](http://yapi.yishou.com/project/128/interface/api/33361) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/Supply/saveSupplyPlatformInfo`
 */
export const saveSupplyPlatformInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveSupplyPlatformInfoRequestConfig, requestData), ...args);
};
saveSupplyPlatformInfo.requestConfig = saveSupplyPlatformInfoRequestConfig;
/**
 * 接口 [获取私密信息↗](http://yapi.yishou.com/project/128/interface/api/33510) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/getInformationPrivate`
 */
const getInformationPrivateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/getInformationPrivate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "getType"],
        properties: {
            supply_id: { type: "string", description: "供应商名称" },
            getType: {
                type: "string",
                description: "查看字段 ：payees：银行信息 ， supply_mobile_phone：供应商手机 ，supply_address：供应商地址 ,supply_wechat:供应商微信,all:所有私密信息",
            },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            payees: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        payee_name: { type: "string", description: '"******"' },
                        payee_bank: { type: "string", description: '"******"' },
                        payee_bank_account: { type: "string", description: '"******"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"payee_name":"******","payee_bank":"******","payee_bank_account":"******"}]',
            },
            supply_mobile_phone: { type: "string", description: '"******"' },
            supply_address: { type: "string", description: '"******"' },
            supply_wechat: { type: "string", description: '"******"' },
            supply_balance: { type: "string", description: '"******"' },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getInformationPrivate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取私密信息↗](http://yapi.yishou.com/project/128/interface/api/33510) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/getInformationPrivate`
 */
export const getInformationPrivate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInformationPrivateRequestConfig, requestData), ...args);
};
getInformationPrivate.requestConfig = getInformationPrivateRequestConfig;
/**
 * 接口 [获取供应商信息↗](http://yapi.yishou.com/project/128/interface/api/33558) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/Supply/UpdateSupply/supply_id/:supply_id`
 */
const supplyIdRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/UpdateSupply/supply_id/:supply_id",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: ["supply_id"],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            pg_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { pgid: { type: "string" }, pgname: { type: "string" } },
                    required: ["pgid", "pgname"],
                },
            },
            floor: {
                type: "object",
                properties: {
                    "1": { type: "object", properties: { value: { type: "string" }, label: { type: "string" } } },
                    "2": { type: "object", properties: { value: { type: "string" }, label: { type: "string" } } },
                    "3": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "4": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "5": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "6": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "7": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "8": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "9": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "10": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "11": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "12": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "13": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "14": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "15": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "16": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "17": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "18": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "19": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "20": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "21": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "22": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "23": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "24": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "25": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "26": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "27": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "28": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "29": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "30": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "31": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "32": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "33": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "34": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "35": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "36": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "37": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "38": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "39": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "40": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "41": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "42": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "43": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "44": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "45": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "46": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "47": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "48": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "49": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "50": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "51": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "52": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "53": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "54": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "55": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "56": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "57": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "58": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "59": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "60": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "61": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "62": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "63": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "64": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "65": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "66": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "67": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "68": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "69": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "70": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "71": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "72": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "73": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "74": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "75": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "76": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "77": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "78": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "79": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "80": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "81": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "82": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "83": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "84": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "85": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "86": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "87": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "88": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "89": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "90": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "91": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "92": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "93": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "94": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "95": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "96": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "97": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "98": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "99": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "100": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "101": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                    "102": { type: "object", properties: { value: { type: "number" }, label: { type: "number" } } },
                },
            },
            supply_area: {
                type: "array",
                items: {
                    type: "object",
                    properties: { supply_area_id: { type: ["number", "string"] }, supply_area: { type: "string" } },
                    required: ["supply_area_id", "supply_area"],
                },
            },
            market: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        key: { type: "string" },
                        label: { type: "string" },
                        show_brand: { type: "string" },
                        children: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: { key: { type: "string" }, label: { type: "string" }, show_brand: { type: "string" } },
                                required: ["key", "label", "show_brand"],
                            },
                        },
                    },
                    required: ["key", "label", "show_brand", "children"],
                },
            },
            age_group: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, key: { type: "string" } },
                    required: ["label", "key"],
                },
            },
            style: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            category: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string" },
                        label: { type: "string" },
                        parent_id: { type: "string" },
                        children: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    value: { type: "string" },
                                    label: { type: "string" },
                                    parent_id: { type: "string" },
                                    children: {
                                        type: "array",
                                        items: {
                                            type: "object",
                                            properties: {
                                                value: { type: "string" },
                                                label: { type: "string" },
                                                parent_id: { type: "string" },
                                            },
                                            required: ["value", "label", "parent_id"],
                                        },
                                    },
                                },
                                required: ["value", "label", "parent_id", "children"],
                            },
                        },
                    },
                    required: ["value", "label", "parent_id", "children"],
                },
            },
            pickers: {
                type: "array",
                items: {
                    type: "object",
                    properties: { pg_id: { type: "string" }, pg_name: { type: "string" } },
                    required: ["pg_id", "pg_name"],
                },
            },
            banks: { type: "array", items: { type: "string" } },
            supply_developer: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            follower: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" }, admin_status: { type: "string" } },
                    required: ["value", "label", "admin_status"],
                },
            },
            pre_storage_admin_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            child_market: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            wx_nickname: { type: "string" },
            cats: { type: "array", items: { type: "string" } },
            settle_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
            defectiveGroupOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            defectiveGroupMemberOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            refundMemberOption: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            member_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            picker_group_member_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            supply: {
                type: "object",
                properties: {
                    supply_id: { type: "string" },
                    supply_name: { type: "string" },
                    supply_mobile_phone: { type: "string" },
                    supply_telephone: { type: "string" },
                    supply_wechat: { type: "string" },
                    supply_status: { type: "string" },
                    limit_day: { type: "string" },
                    create_time: { type: "string" },
                    create_admin: { type: "string" },
                    update_time: { type: "string" },
                    pgid: { type: "string" },
                    supply_floor: { type: "string" },
                    supply_area_id: { type: "string" },
                    is_scal: { type: "string" },
                    market_id: { type: "string" },
                    supply_level: { type: "string" },
                    settle_type: { type: "string" },
                    settle_days: { type: "string" },
                    next_settle_start_time: { type: "string" },
                    last_settle_time: { type: "string" },
                    need_settle_flag: { type: "string" },
                    purchase_status: { type: "string" },
                    share_status: { type: "string" },
                    the_new_flag: { type: "string" },
                    is_signed_contract: { type: "string" },
                    city: { type: "string" },
                    remark: { type: "string" },
                    supplier_num: { type: "string" },
                    pic: { type: "string" },
                    auto_time: { type: "string" },
                    is_strength: { type: "string" },
                    license: { type: "string" },
                    season: { type: "array", items: { type: "string" } },
                    age_group: { type: "array", items: { type: "string" } },
                    cat_ids: { type: "string" },
                    styles: { type: "array", items: { type: "string" } },
                    cat_char: { type: "string" },
                    styles_char: { type: "string" },
                    is_show_brand: { type: "string" },
                    advantage: { type: "string" },
                    disadvantage: { type: "string" },
                    avatar: { type: "string" },
                    is_full: { type: "string" },
                    is_self: { type: "string" },
                    supply_nickname: { type: "string" },
                    pg_member_id: { type: "string" },
                    pg_id: { type: "string" },
                    is_live: { type: "string" },
                    live_type: { type: "string" },
                    live_num: { type: "string" },
                    is_lower_enter: { type: "string" },
                    is_ka: { type: "string" },
                    m_goal: { type: "string" },
                    pg_say: { type: "string" },
                    disable_count: { type: "string" },
                    disable_remark: { type: "string" },
                    is_order_ability: { type: "string" },
                    shopId: { type: "number" },
                    is_all_style: { type: "string" },
                    baobmobile: { type: "string" },
                    baob_allot: { type: "string" },
                    fans: { type: "string" },
                    baob_stock_sharing: { type: "string" },
                    first_sync_time: { type: "string" },
                    picture: { type: "array", items: { type: "string" } },
                    wcg_order_sync_time: { type: "string" },
                    supply_grade: { type: "array", items: { type: "string" } },
                    second_styles: { type: "array", items: { type: "string" } },
                    is_benchmarking: { type: "string" },
                    is_self_need_audit: { type: "string" },
                    supply_picker_group_member_id: { type: "string" },
                    as_plan: { type: "string" },
                    all_rebuild_plan: { type: "string" },
                    supply_developer_admin: { type: "string" },
                    dgid: { type: "string" },
                    dg_member_id: { type: "string" },
                    recommend_desc: { type: "string" },
                    follower_admin_id: { type: "string" },
                    is_screenshot_for_add_goods: { type: "string" },
                    sub_acct_no: { type: "string" },
                    is_sign: { type: "string" },
                    supply_action_value: { type: "string" },
                    father_market: { type: "string" },
                    brand_id: { type: "string" },
                    invitation_in: { type: "string" },
                    open_deposit: { type: "string" },
                    current_security_amount: { type: "string" },
                    need_security_amount: { type: "string" },
                    pay_method: { type: "string" },
                    effective_time: { type: "string" },
                    self_set_sole: { type: "string" },
                    no_reason_return: { type: "string" },
                    is_platform: { type: "string" },
                    refund_model: { type: "string" },
                    wx_picture: { type: "string" },
                    wx_no: { type: "string" },
                    supply_video: { type: "string" },
                    supply_images: { type: "array", items: { type: "string" } },
                    sale_level: { type: "string" },
                    refund_service_fee_rate: { type: "string" },
                    update_sale_level: { type: "number" },
                    update_refund_service_fee_rate: { type: "string" },
                    service_fee_rate: { type: "string" },
                    update_service_fee_rate: { type: "string" },
                    platform_security_amount: { type: "string" },
                    platform_year_amount: { type: "string" },
                    refund_member_id: { type: "string" },
                    expand_admin_id: { type: "string" },
                    reject_accept: { type: "string" },
                    special_sale: { type: "string" },
                    self_operation_special: { type: "string" },
                    goods_exempt_examine: { type: "string" },
                    return_limit_ratio: { type: "string" },
                    platform_switch: { type: "string" },
                    platform_begin_time: { type: "string" },
                    is_push_wcg_plan: { type: "string" },
                    is_sync_supply_stock: { type: "string" },
                    week_new_limit: { type: "null" },
                    month_new_limit: { type: "null" },
                    is_show_best_choice: { type: "string" },
                    contract_type_id: { type: "string" },
                    is_platform_text: { type: "string" },
                    no_reason_return_text: { type: "string" },
                    sale_level_text: { type: "string" },
                    update_sale_level_text: { type: "string" },
                    new_audit_status: { type: "string" },
                    is_show_best_choice_text: { type: "string" },
                    pic_url: { type: "string" },
                    license_url: { type: "string" },
                    avatar_url: { type: "string" },
                    wx_picture_url: { type: "string" },
                    picture_url: { type: "array", items: { type: "string" } },
                    payees: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                payee_id: { type: "string" },
                                payee_name: { type: "string" },
                                payee_bank: { type: "string" },
                                payee_bank_account: { type: "string" },
                                cnap: { type: "string" },
                                cnap_name: { type: "string" },
                                is_default: { type: "string" },
                            },
                        },
                    },
                    is_default: { type: "number" },
                    brands: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                brand_id: { type: "string" },
                                brand_name: { type: "string" },
                                status: { type: "number" },
                                is_main: { type: "string" },
                            },
                        },
                    },
                    is_main: { type: "number" },
                    brand: { type: "string" },
                    supply_character: { type: "string" },
                    is_deduct_repurchase: { type: "string" },
                    no_reason_begin_time: { type: "string" },
                    supply_address: { type: "string" },
                    lng: { type: "string" },
                    lat: { type: "string" },
                    supply_excess_point_goods: { type: "string" },
                    plan_time_out_days: { type: "string" },
                    is_auto_billing: { type: "string" },
                    is_auto_cancel_plan: { type: "string" },
                    create_order_way: { type: "string" },
                    take_stock_on_plan: { type: "string" },
                    bill_merger_date: { type: "array", items: { type: "number" } },
                    pre_storage_admin: { type: "string" },
                    is_return_profit: { type: "string" },
                    is_return_profit_text: { type: "string" },
                    return_profit_month: { type: "string" },
                    clearing_form: { type: "string" },
                    clearing_form_text: { type: "string" },
                    period_profit: { type: "string" },
                    period_profit_text: { type: "string" },
                    reserve_price: { type: "string" },
                    return_profit_rule: { type: "array", items: { type: "string" } },
                    activity_fee_buckle: { type: "string" },
                    open_qz_auto_buckle: { type: "string" },
                    can_return_days: { type: "string" },
                },
            },
            options: {
                type: "object",
                properties: {
                    pay_methods: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { label: { type: "string" }, value: { type: "string" } },
                            required: ["label", "value"],
                        },
                    },
                    refund_models: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { value: { type: "string" }, label: { type: "string" } },
                            required: ["value", "label"],
                        },
                    },
                },
            },
            refund_models: {
                type: "object",
                properties: { value: { type: "string", description: "值" }, label: { type: "string", description: "描述" } },
                required: ["value", "label"],
                description: "退货模式",
            },
        },
        required: ["refund_models"],
    },
    requestFunctionName: "supplyId",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商信息↗](http://yapi.yishou.com/project/128/interface/api/33558) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `GET /erp/Supply/UpdateSupply/supply_id/:supply_id`
 */
export const supplyId = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(supplyIdRequestConfig, requestData), ...args);
};
supplyId.requestConfig = supplyIdRequestConfig;
/**
 * 接口 [批量更新供应商状态↗](http://yapi.yishou.com/project/128/interface/api/33559) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/batchUpdateSupply`
 */
const batchUpdateSupplyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/batchUpdateSupply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_ids[]", "remark", "status"],
        properties: {
            "supply_ids[]": { type: "string", description: "供应商ID数组" },
            remark: { type: "string", description: "备注" },
            status: { type: "string", description: "更改状态  1 启用 2 禁用" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "导出错误文件，如果没有，该字段为空。" } },
    },
    requestFunctionName: "batchUpdateSupply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批量更新供应商状态↗](http://yapi.yishou.com/project/128/interface/api/33559) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/batchUpdateSupply`
 */
export const batchUpdateSupply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchUpdateSupplyRequestConfig, requestData), ...args);
};
batchUpdateSupply.requestConfig = batchUpdateSupplyRequestConfig;
/**
 * 接口 [更改供应商支付方式↗](http://yapi.yishou.com/project/128/interface/api/33568) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/updatePayMethod`
 */
const updatePayMethodRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/updatePayMethod",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "pay_method"],
        properties: { supply_id: { type: "string" }, pay_method: { type: "string", description: "1转账，2分账" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updatePayMethod",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [更改供应商支付方式↗](http://yapi.yishou.com/project/128/interface/api/33568) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/updatePayMethod`
 */
export const updatePayMethod = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updatePayMethodRequestConfig, requestData), ...args);
};
updatePayMethod.requestConfig = updatePayMethodRequestConfig;
/**
 * 接口 [修改供应商状态↗](http://yapi.yishou.com/project/128/interface/api/36490) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/UpdateSingleSupplyStatus`
 */
const updateSingleSupplyStatusRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/UpdateSingleSupplyStatus",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "status", "remark"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            status: { type: "string", description: "供应商状态:{0:禁用,1:启用}" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateSingleSupplyStatus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [修改供应商状态↗](http://yapi.yishou.com/project/128/interface/api/36490) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/UpdateSingleSupplyStatus`
 */
export const updateSingleSupplyStatus = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateSingleSupplyStatusRequestConfig, requestData), ...args);
};
updateSingleSupplyStatus.requestConfig = updateSingleSupplyStatusRequestConfig;
/**
 * 接口 [批量修改供应商「前置仓跟进人」↗](http://yapi.yishou.com/project/128/interface/api/36841) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/batchUpdateSupplyPreStorageAdmin`
 */
const batchUpdateSupplyPreStorageAdminRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/batchUpdateSupplyPreStorageAdmin",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_ids[0]", "pre_storage_admin"],
        properties: {
            "supply_ids[0]": { type: "string", description: "供应商id数组" },
            pre_storage_admin: { type: "string", description: "前置仓跟进人id，置空请发送0" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: '"/erp/Common/export?file=csv-202303301755422027.csv"' } },
        additionalProperties: false,
    },
    requestFunctionName: "batchUpdateSupplyPreStorageAdmin",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批量修改供应商「前置仓跟进人」↗](http://yapi.yishou.com/project/128/interface/api/36841) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/batchUpdateSupplyPreStorageAdmin`
 */
export const batchUpdateSupplyPreStorageAdmin = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchUpdateSupplyPreStorageAdminRequestConfig, requestData), ...args);
};
batchUpdateSupplyPreStorageAdmin.requestConfig = batchUpdateSupplyPreStorageAdminRequestConfig;
/**
 * 接口 [模糊搜索内部已启用的员工↗](http://yapi.yishou.com/project/128/interface/api/36850) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/searchEnabledAdminByNameLike`
 */
const searchEnabledAdminByNameLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/searchEnabledAdminByNameLike",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["admin_name"],
        properties: { admin_name: { type: "string", description: "内部员工id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            enable_admin_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: '"250"' },
                        label: { type: "string", description: '"1001"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"value":"250","label":"1001"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "searchEnabledAdminByNameLike",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [模糊搜索内部已启用的员工↗](http://yapi.yishou.com/project/128/interface/api/36850) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/searchEnabledAdminByNameLike`
 */
export const searchEnabledAdminByNameLike = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(searchEnabledAdminByNameLikeRequestConfig, requestData), ...args);
};
searchEnabledAdminByNameLike.requestConfig = searchEnabledAdminByNameLikeRequestConfig;
/**
 * 接口 [返回所有已启用的员工↗](http://yapi.yishou.com/project/128/interface/api/37120) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/supply/getAllEnableAdmin`
 */
const getAllEnableAdminRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/supply/getAllEnableAdmin",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            enable_admin_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
                description: "已启用的员工列表",
            },
        },
    },
    requestFunctionName: "getAllEnableAdmin",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [返回所有已启用的员工↗](http://yapi.yishou.com/project/128/interface/api/37120) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/supply/getAllEnableAdmin`
 */
export const getAllEnableAdmin = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getAllEnableAdminRequestConfig, requestData), ...args);
};
getAllEnableAdmin.requestConfig = getAllEnableAdminRequestConfig;
/**
 * 接口 [小店分发设置↗](http://yapi.yishou.com/project/128/interface/api/37318) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyShopDispense/UpdateDispenseSetting`
 */
const updateDispenseSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyShopDispense/UpdateDispenseSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "is_participation_dispense"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            effective_date_of_agreement: { type: "string", description: "协议生效日" },
            positive_price_rate: { type: "string", description: "正价抽佣比例" },
            special_price_rate: { type: "string", description: "特价抽佣比例" },
            is_participation_dispense: { type: "string", description: "是否参与小店分发佣金{1:是,2:否}" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { code: { type: "string" }, msg: { type: "string" } },
        required: ["code", "msg"],
    },
    requestFunctionName: "updateDispenseSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [小店分发设置↗](http://yapi.yishou.com/project/128/interface/api/37318) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyShopDispense/UpdateDispenseSetting`
 */
export const updateDispenseSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateDispenseSettingRequestConfig, requestData), ...args);
};
updateDispenseSetting.requestConfig = updateDispenseSettingRequestConfig;
/**
 * 接口 [小店分发设置-获取↗](http://yapi.yishou.com/project/128/interface/api/37336) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyShopDispense/GetDispenseSetting`
 */
const getDispenseSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyShopDispense/GetDispenseSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            shop_distribute_setting: {
                type: "object",
                properties: {
                    supply_id: { type: "string", description: "供应商id" },
                    is_participation_dispense: { type: "number", description: "是否参与小店分发{1:是,2:否}" },
                    effective_date: { type: "string", description: "生效日期" },
                    normal_rate: { type: "string", description: "正价比例" },
                    special_offer_rate: { type: "string", description: "特价比例" },
                },
                description: "小店分发设置信息",
            },
            no_reason_return: { type: "boolean", description: "是否开启了无理由退货" },
        },
        required: ["no_reason_return"],
    },
    requestFunctionName: "getDispenseSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [小店分发设置-获取↗](http://yapi.yishou.com/project/128/interface/api/37336) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyShopDispense/GetDispenseSetting`
 */
export const getDispenseSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getDispenseSettingRequestConfig, requestData), ...args);
};
getDispenseSetting.requestConfig = getDispenseSettingRequestConfig;
/**
 * 接口 [登陆后获取协议签署判断↗](http://yapi.yishou.com/project/128/interface/api/37408) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.35.0`
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
const checkPinganRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/SupplyPayee/checkPingan",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["baob_mobile_phone", "supply_id"],
        properties: {
            baob_mobile_phone: { type: "string", description: "爆版主账号手机号码" },
            supply_id: { type: "string", description: "商家ID，单个" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            need_sign_supply_id: { type: "string", description: "需要签约的供应商id，为空不需要签约" },
            is_sign_pingan_agreement: {
                type: "string",
                description: "子账户是否签署结算通协议:{1:是;0:否}",
                tag: "爆版4.35.0",
            },
            is_authentication: { type: "string", description: "子账户是否鉴权:{1:是;0:否}", tag: "爆版4.35.0" },
        },
        required: ["need_sign_supply_id", "is_sign_pingan_agreement", "is_authentication"],
    },
    requestFunctionName: "checkPingan",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [登陆后获取协议签署判断↗](http://yapi.yishou.com/project/128/interface/api/37408) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @标签 `爆版4.35.0`
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
export const checkPingan = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(checkPinganRequestConfig, requestData), ...args);
};
checkPingan.requestConfig = checkPinganRequestConfig;
/**
 * 接口 [平安协议签署↗](http://yapi.yishou.com/project/128/interface/api/37417) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
const agreementRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/SupplyPayee/agreement",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_ids", "ip", "baob_user_id", "baob_user_name", "baob_mobile_phone"],
        properties: {
            supply_ids: { type: "string", description: "供应商ID （逗号分隔）" },
            ip: { type: "string", description: "IP地址（用户IP）" },
            mac: { type: "string", description: "MAC地址（无法获取，可以不传）" },
            baob_user_id: { type: "string", description: "爆版用户ID" },
            baob_user_name: { type: "string", description: "爆版用户昵称" },
            baob_mobile_phone: { type: "string", description: "爆版店铺主账号手机号码" },
        },
    },
    responseDataJsonSchema: { type: "object", title: "empty object", properties: {} },
    requestFunctionName: "agreement",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [平安协议签署↗](http://yapi.yishou.com/project/128/interface/api/37417) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
export const agreement = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(agreementRequestConfig, requestData), ...args);
};
agreement.requestConfig = agreementRequestConfig;
/**
 * 接口 [销户↗](http://yapi.yishou.com/project/128/interface/api/37606) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/closeAcctInfo`
 */
const closeAcctInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/closeAcctInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id"],
        properties: { supply_id: { type: "string", description: "供应商id" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "closeAcctInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [销户↗](http://yapi.yishou.com/project/128/interface/api/37606) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/Supply/closeAcctInfo`
 */
export const closeAcctInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(closeAcctInfoRequestConfig, requestData), ...args);
};
closeAcctInfo.requestConfig = closeAcctInfoRequestConfig;
/**
 * 接口 [获取商家子账户信息↗](http://yapi.yishou.com/project/128/interface/api/38555) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/getSupplySubAcctInfo`
 */
const getSupplySubAcctInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPayee/getSupplySubAcctInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["supply_id"], properties: { supply_id: { type: "string" } } },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            supply_id: { type: "string" },
            is_sub_acct: { type: "number", description: "是否存在子账户 0 否 1 是" },
            real_name_type: {
                type: "string",
                description: "绑定类型 0 未知 1:个人银行卡;2:个体工商户对公账户;3:企业对公账户;",
            },
            sub_acct_type: {
                type: "string",
                description: "子账户开户类型 {0:未知;1:非实名开户;2:个人银行卡;3:个体工商户对公账户;4:企业对公账户;}",
            },
            is_application_ing: { type: "number", description: "是否存在进行中的对公账户鉴权申请 0 否 1 是" },
            supply_sub_acct_info: {
                type: "object",
                properties: {
                    supply_id: { type: "string", description: "商家ID" },
                    shopId: { type: "string", description: "爆版ID" },
                    supply_status: { type: "string", description: "启用状态{0:禁用,1:启用}" },
                    sub_acct_no: { type: "string", description: "平安银行子账户" },
                    is_authentication: { type: "string", description: "子账户是否鉴权:{1:是;2:否}" },
                    corporate_name: { type: "string", description: "姓名|法人姓名" },
                    id_type: {
                        type: "string",
                        description: "证件类型{1:身份证;3:回乡证(港澳台居民通行证);4:中国护照;5:台胞证(台湾居民来往大陆通行证);19:外国护照;}",
                        mock: { mock: "0" },
                    },
                    id_number: { type: "string", description: "证件号码" },
                    company_name: { type: "string", description: "公司名称" },
                    credit_code: { type: "string", description: "统一社会信用代码" },
                    sub_acct_type: {
                        type: "string",
                        description: "开户类型{1:非实名开户;2:个人银行卡;3:个体工商户对公账户;4:企业对公账户;}",
                    },
                    bind_sub_acct_type: {
                        type: "string",
                        description: "绑定子账户类型{1:个人银行卡;2:个体工商户对公账户;3:企业对公账户;}",
                    },
                    bind_sub_acct_phone: { type: "string", description: "手机号码" },
                    application_id: { type: "null", description: "对公账户鉴权申请ID" },
                    payee_name: { type: "null", description: "对公账户鉴权申请-收款人姓名" },
                    payee_bank: { type: "null", description: "对公账户鉴权申请-开户行名称" },
                    payee_bank_account: { type: "null", description: "对公账户鉴权申请-账号" },
                    payee_phone: { type: "null", description: "对公账户鉴权申请-手机号码" },
                    payee_type: {
                        type: "null",
                        description: "对公账户鉴权申请-绑卡类型{1:个人银行卡;2:个体工商户对公账户;3:企业对公账户;}",
                    },
                    is_enabled: { type: "null", description: "对公账户鉴权申请-是否有效{1:有效;2:无效;}" },
                    is_default: { type: "string", description: "对公账户鉴权申请-是否默认账户{1:是;2:否;}" },
                    created_at: { type: "null", description: "对公账户鉴权申请-创建时间" },
                    updated_at: { type: "null" },
                },
                description: "商家信息",
                required: ["is_default"],
            },
        },
    },
    requestFunctionName: "getSupplySubAcctInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取商家子账户信息↗](http://yapi.yishou.com/project/128/interface/api/38555) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/getSupplySubAcctInfo`
 */
export const getSupplySubAcctInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplySubAcctInfoRequestConfig, requestData), ...args);
};
getSupplySubAcctInfo.requestConfig = getSupplySubAcctInfoRequestConfig;
/**
 * 接口 [绑卡鉴权申请↗](http://yapi.yishou.com/project/128/interface/api/38557) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/bindSupplySubAcct`
 */
const bindSupplySubAcctRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPayee/bindSupplySubAcct",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "supply_id",
            "corporate_name",
            "id_type",
            "id_number",
            "payee_bank",
            "payee_bank_account",
            "payee_phone",
            "bind_sub_acct_type",
            "company_name",
            "credit_code",
            "is_default",
        ],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            corporate_name: { type: "string", description: "姓名" },
            id_type: {
                type: "string",
                description: "证件类型{1:身份证;3:回乡证(港澳台居民通行证);4:中国护照;5:台胞证(台湾居民来往大陆通行证);19:外国护照;}",
            },
            id_number: { type: "string", description: "证件号码" },
            payee_bank: { type: "string", description: "开户行名称" },
            payee_bank_account: { type: "string", description: "卡号" },
            payee_phone: { type: "string", description: "手机号码" },
            bind_sub_acct_type: {
                type: "string",
                description: "账户类型{1:个人银行卡;2:个体工商户对公账户;3:企业对公账户;}",
            },
            company_name: { type: "string", description: "企业名称" },
            credit_code: { type: "string", description: "统一社会信用代码" },
            is_default: { type: "string", description: "是否默认卡 {1:是;2:否;}" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            application_id: { type: "string", description: "对公鉴权申请ID（个人银行卡鉴权为0），用于取消申请。" },
        },
    },
    requestFunctionName: "bindSupplySubAcct",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [绑卡鉴权申请↗](http://yapi.yishou.com/project/128/interface/api/38557) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/bindSupplySubAcct`
 */
export const bindSupplySubAcct = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(bindSupplySubAcctRequestConfig, requestData), ...args);
};
bindSupplySubAcct.requestConfig = bindSupplySubAcctRequestConfig;
/**
 * 接口 [重发验证码↗](http://yapi.yishou.com/project/128/interface/api/38559) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/retryCode`
 */
const retryCodeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPayee/retryCode",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "supply_id",
            "corporate_name",
            "id_type",
            "id_number",
            "payee_bank",
            "payee_bank_account",
            "payee_phone",
            "bind_sub_acct_type",
            "company_name",
            "credit_code",
            "is_default",
        ],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            corporate_name: { type: "string", description: "姓名" },
            id_type: {
                type: "string",
                description: "证件类型{1:身份证;3:回乡证(港澳台居民通行证);4:中国护照;5:台胞证(台湾居民来往大陆通行证);19:外国护照;}",
            },
            id_number: { type: "string", description: "证件号码" },
            payee_bank: { type: "string", description: "开户行名称" },
            payee_bank_account: { type: "string", description: "卡号" },
            payee_phone: { type: "string", description: "手机号码" },
            bind_sub_acct_type: {
                type: "string",
                description: "账户类型{1:个人银行卡;2:个体工商户对公账户;3:企业对公账户;}",
            },
            company_name: { type: "string", description: "企业名称" },
            credit_code: { type: "string", description: "统一社会信用代码" },
            is_default: { type: "string", description: "是否默认卡 {1:是;2:否;}" },
        },
    },
    responseDataJsonSchema: {},
    requestFunctionName: "retryCode",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [重发验证码↗](http://yapi.yishou.com/project/128/interface/api/38559) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/retryCode`
 */
export const retryCode = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(retryCodeRequestConfig, requestData), ...args);
};
retryCode.requestConfig = retryCodeRequestConfig;
/**
 * 接口 [取消申请↗](http://yapi.yishou.com/project/128/interface/api/38561) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/cancelApplication`
 */
const cancelApplicationRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPayee/cancelApplication",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["application_id"],
        properties: { application_id: { type: "string", description: "对公鉴权申请ID" } },
    },
    responseDataJsonSchema: {},
    requestFunctionName: "cancelApplication",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [取消申请↗](http://yapi.yishou.com/project/128/interface/api/38561) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/cancelApplication`
 */
export const cancelApplication = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cancelApplicationRequestConfig, requestData), ...args);
};
cancelApplication.requestConfig = cancelApplicationRequestConfig;
/**
 * 接口 [提交校验↗](http://yapi.yishou.com/project/128/interface/api/38573) 的 **请求配置**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/submitCheck`
 */
const submitCheckRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplyPayee/submitCheck",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "supply_id",
            "corporate_name",
            "id_type",
            "id_number",
            "payee_bank",
            "payee_bank_account",
            "payee_phone",
            "bind_sub_acct_type",
            "company_name",
            "credit_code",
            "is_default",
            "check_code",
            "order_no",
            "auth_amt",
        ],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            corporate_name: { type: "string", description: "姓名" },
            id_type: {
                type: "string",
                description: "证件类型{1:身份证;3:回乡证(港澳台居民通行证);4:中国护照;5:台胞证(台湾居民来往大陆通行证);19:外国护照;}",
            },
            id_number: { type: "string", description: "证件号码" },
            payee_bank: { type: "string", description: "开户行名称" },
            payee_bank_account: { type: "string", description: "卡号" },
            payee_phone: { type: "string", description: "手机号码" },
            bind_sub_acct_type: {
                type: "string",
                description: "账户类型{1:个人银行卡;2:个体工商户对公账户;3:企业对公账户;}",
            },
            company_name: { type: "string", description: "企业名称" },
            credit_code: { type: "string", description: "统一社会信用代码" },
            is_default: { type: "string", description: "是否默认卡 {1:是;2:否;}" },
            check_code: { type: "string", description: "个人银行卡 验证码" },
            order_no: { type: "string", description: "对公鉴权 验证码" },
            auth_amt: { type: "string", description: "对公鉴权 打款金额" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "submitCheck",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [提交校验↗](http://yapi.yishou.com/project/128/interface/api/38573) 的 **请求函数**
 *
 * @分类 [供应商↗](http://yapi.yishou.com/project/128/interface/api/cat_2267)
 * @请求头 `POST /erp/SupplyPayee/submitCheck`
 */
export const submitCheck = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(submitCheckRequestConfig, requestData), ...args);
};
submitCheck.requestConfig = submitCheckRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/supply2267.js